import { version } from '../../../apps/web/package.json';

export const VERSION_CONFIG = {
  appVersion: version,
  appName: 'Net3',
};
